import React from 'react'
import PropTypes from 'prop-types'
import {MANDATORY_FIELDS, MESSAGE_PLACEHOLDER} from './const';
import ValidationMessageList from "../../../validation/component/ValidationMessageList";

export const MessageBox = ({messageList}) => {
    if (Array.isArray(messageList) && messageList.length === 0) {
        return null
    }

    const classNameLabel = "alert alert-danger"

    return (<div className={classNameLabel} role="alert">
        <ContentBox validationMessageList={messageList}/>
    </div>)
}


export const ContentBox = ({validationMessageList}) => {
    return (
        <div>
            {validationMessageList.map(message => {
                return <Message message={message}/>
            })}
        </div>
    )
}

const Message = ({message}) => {
    const msg = message.message.replace(MESSAGE_PLACEHOLDER, () => {
        const field = MANDATORY_FIELDS.find(el => el.id === message.messageId)
        return field ? field.value : message.messageId
    })

    return (<div>{msg}</div>)
}

ValidationMessageList.propTypes = {
    validationMessageList: PropTypes.array,
    success: PropTypes.object,
}

export default MessageBox


// WEBPACK FOOTER //
// ./src/modules/partner/component/form/MessageBox.js